import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  headTitle: 'Något gick fel....',
  title: 'Hoppsan! Det verkar som att något gick fel...',
  subheader: 'Det verkar som att vi inte kunde hitta sidan du letade efter',
  buttonText: 'Gå tillbaka till startsidan',
}
